import { filter, groupBy, orderBy } from 'lodash';

import { formatTime } from '../../../../services/timeService';
import { dateTimeFormat } from '../../../../services/timeService/types';
import type { IEventsList } from '../EventsList';
import useClinicalEvent from './useClinicalEvent';
import useClinicalRecordEvent from './useClinicalRecordEvent';
import useCustomEvent from './useCustomEvent';
import useFallEvent from './useFallEvent';
import useFirstLoginEvent from './useFirstLoginEvent';
import useGeneralQuestionnaireEvent from './useGeneralQuestionnaireEvent';
import useLEFSEvent from './useLEFSEvent';
import useMeetingEvent from './useMeetingEvent';
import usePSFSEvent from './usePSFSEvent';
import useSurgeryEvent from './useSurgeryEvent';
import useTherapistHistoryEvent from './useTherapistHistoryEvent';
import useVASEvent from './useVASEvent';

export default function useTimeline(patientUuid: string) {
  const firstLoginEvent = useFirstLoginEvent(patientUuid);
  const meetingEventList = useMeetingEvent(patientUuid);
  const lEFSEventList = useLEFSEvent(patientUuid);
  const VASEventList = useVASEvent(patientUuid);
  const PSFSEventList = usePSFSEvent(patientUuid);
  const generalQuestionnaireList = useGeneralQuestionnaireEvent(patientUuid);
  const clinicalRecordEventList = useClinicalRecordEvent(patientUuid);
  const fallEventList = useFallEvent(patientUuid);
  const surgeriesEventList = useSurgeryEvent(patientUuid);
  const clinicalEventList = useClinicalEvent(patientUuid);
  const customEventList = useCustomEvent(patientUuid);
  const therapistHistoryList = useTherapistHistoryEvent(patientUuid);

  const filteredEventsList = filter(
    [
      firstLoginEvent,
      ...meetingEventList,
      ...lEFSEventList,
      ...VASEventList,
      ...PSFSEventList,
      ...generalQuestionnaireList,
      ...surgeriesEventList,
      ...fallEventList,
      ...clinicalRecordEventList,
      ...clinicalEventList,
      ...customEventList,
      ...therapistHistoryList,
    ],
    (x?: { date?: string }) => x && x.date,
  );
  /*
   order all events by date, and return it in one list
  */
  const orderedEventsList = orderBy(filteredEventsList, 'date', 'desc');
  /*
   group events list by date
  */
  return groupBy(orderedEventsList, (x: IEventsList) =>
    formatTime(x.date, dateTimeFormat.COMMA_YEAR_FORMAT),
  );
}
